/*
  BOF page buy box (sections/bof-offer.liquid): the box selection, the CTA and sticky
  bar that follow it, the delivery date, and the cart add.

  The add is the homepage tier cards' (sections/hp-tiers.liquid), same behaviour:
  lines from GET /api/tiers for the tier's key (3_month_connoisseur,
  3_month_explorer, starter), the same properties (_bundleId, _role,
  _flatDiscount on gifts, _milestoneProgram, _milestoneTier) and the same two cart
  attributes, existing bundles removed by line key first (the cart is never
  cleared), one cart read after the add to repair races, then /checkout. So an
  order from this page, its Recharge subscription and its milestone tags match a
  homepage or quiz-path order.

  Loaded with defer: an inline copy runs during parse and holds up first paint
  (the Brewzle page, 2026-09-21). The section marks its root with
  data-bof-section="offer"; each box is a [data-bof-option] around a radio, and a CTA
  is any [data-bof-cta] inside the root, adding the selected box. Every step is
  announced as a bubbling bof-offer:* CustomEvent, which
  assets/analytics-posthog-funnel.js turns into PostHog events.
*/
(function () {
  var roots = document.querySelectorAll('[data-bof-section="offer"]');
  for (var i = 0; i < roots.length; i++) initOffer(roots[i]);

  function initOffer(root) {
    var status = root.querySelector('[data-bof-status]');
    var apiBase = String(root.getAttribute('data-api-base') || window.__QUIZ_API_BASE__ || '').replace(/\/$/, '');

    var TIER_KEYS = { connoisseur: '3_month_connoisseur', explorer: '3_month_explorer', starter: 'starter' };
    var MILESTONE_TIER = { connoisseur: '3_month_connoisseur', explorer: 'explorer', starter: 'starter' };
    var MILESTONE_PROGRAM = '3-month-milestone';
    var REQUEST_TIMEOUT_MS = 12000;
    var ADD_TIMEOUT_MS = 26000;
    var CART_RETRIES = 2;
    var LOADING_LABEL = 'Preparing your cart';
    var RETRY_LABEL = 'Could not add, tap to try again';
    var inFlight = false;

    // This file loads async, so it can run before the analytics file listens: every event
    // is also kept in window.__bofOfferQueue, which the analytics file replays once at start.
    function announce(state, detail) {
      var d = detail || {};
      (window.__bofOfferQueue = window.__bofOfferQueue || []).push({ state: state, detail: d });
      try {
        root.dispatchEvent(new CustomEvent('bof-offer:' + state, { bubbles: true, detail: d }));
      } catch (e) { /* CustomEvent unsupported: analytics only */ }
    }

    function tagError(err, stage, path, httpStatus) {
      if (err && typeof err === 'object') {
        if (stage && !err.stage) err.stage = stage;
        if (path && !err.cart_endpoint) err.cart_endpoint = path;
        if (httpStatus && !err.http_status) err.http_status = httpStatus;
      }
      return err;
    }

    function pause(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function retryAfterMs(res) {
      var h = res && res.headers && res.headers.get ? res.headers.get('Retry-After') : null;
      var n = h ? Number(h) : NaN;
      return Number.isFinite(n) && n > 0 ? Math.min(n * 1000, 8000) : null;
    }

    // One deadline per attempt; 429 and 5xx (and a dropped connection) retry twice with a
    // short backoff, the way the taste-profile CTA and the offer pages do. A body that is
    // not JSON (Shopify's connection check) fails with the status so the reporter can
    // classify it.
    async function fetchJson(path, init, stage, reportToken) {
      for (var attempt = 0; ; attempt++) {
        try {
          return await fetchJsonOnce(path, init, stage, reportToken);
        } catch (err) {
          var httpStatus = err && err.http_status;
          var message = err && err.message ? err.message : '';
          var retryable = attempt < CART_RETRIES && (httpStatus === 429 || httpStatus >= 500 || (!httpStatus && !/no JSON|is not set|missing/.test(message)));
          if (!retryable) throw err;
          await pause(err && err._retryAfter ? err._retryAfter : 400 * (attempt + 1));
        }
      }
    }
    async function fetchJsonOnce(path, init, stage, reportToken) {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT_MS) : null;
      var res;
      try {
        var options = Object.assign({ credentials: 'same-origin' }, init || {});
        if (ctrl) options.signal = ctrl.signal;
        if (reportToken) options.wlReportToken = reportToken;
        res = await fetch(path, options);
      } catch (caught) {
        if (timer) clearTimeout(timer);
        var err = ctrl && ctrl.signal.aborted ? new Error(path + ' timed out after ' + REQUEST_TIMEOUT_MS + 'ms') : caught;
        if (reportToken && err && typeof err === 'object') err._reportToken = reportToken;
        throw tagError(err, stage, path);
      }
      if (timer) clearTimeout(timer);
      if (!res.ok) {
        var e = new Error(path + ' ' + res.status);
        if (reportToken) e._reportToken = reportToken;
        if (res.status === 429) e._retryAfter = retryAfterMs(res);
        throw tagError(e, stage, path, res.status);
      }
      try { return await res.json(); } catch (parseErr) { throw tagError(new Error(path + ' returned no JSON'), stage, path, res.status); }
    }

    function withDeadline(promise, ms, stage, path) {
      return new Promise(function (resolve, reject) {
        var t = setTimeout(function () { reject(tagError(new Error(path + ' timed out after ' + ms + 'ms'), stage, path)); }, ms);
        promise.then(function (v) { clearTimeout(t); resolve(v); }, function (err) { clearTimeout(t); reject(tagError(err, stage, path)); });
      });
    }

    function normalizeTierEntry(entry) {
      var e = entry && typeof entry === 'object' ? entry : {};
      var rawItems = Array.isArray(e.items) ? e.items : [];
      return rawItems.map(function (obj) {
        var it = obj && typeof obj === 'object' ? obj : {};
        var variant = '';
        if (typeof it.variant === 'number' && Number.isFinite(it.variant)) variant = String(Math.trunc(it.variant));
        else if (typeof it.variant === 'string') variant = it.variant.trim();
        var quantity = Number.isFinite(Number(it.quantity)) ? Number(it.quantity) : 0;
        var sellingPlan = '';
        if (typeof it.sellingPlan === 'number' && Number.isFinite(it.sellingPlan)) sellingPlan = String(Math.trunc(it.sellingPlan));
        else if (typeof it.sellingPlan === 'string') sellingPlan = it.sellingPlan.trim();
        var properties = it.properties && typeof it.properties === 'object' ? it.properties : null;
        var role = typeof it._role === 'string' ? it._role.trim() : '';
        if (!variant || quantity <= 0) return null;
        var item = { id: variant, quantity: quantity };
        if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;
        if (properties) item.properties = properties;
        if (role) item._role = role;
        var fdRaw = it.flatDiscount;
        if (fdRaw != null && fdRaw !== '') {
          if (typeof fdRaw === 'number' && Number.isFinite(fdRaw)) item.flatDiscount = fdRaw;
          else if (typeof fdRaw === 'string' && fdRaw.trim()) {
            var fdNum = Number(fdRaw.trim());
            item.flatDiscount = Number.isFinite(fdNum) ? fdNum : fdRaw.trim();
          }
        }
        return item;
      }).filter(Boolean);
    }

    async function fetchTierItems(key) {
      if (!apiBase) throw tagError(new Error('Quiz API base URL is not set'), 'tier_fetch', '/api/tiers');
      var json = await fetchJson(apiBase + '/api/tiers', { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit' }, 'tier_fetch');
      var tiers = (json && json.data && json.data.tiers) || (json && json.tiers) || null;
      var items = normalizeTierEntry(tiers && tiers[key]);
      if (!items.length) throw tagError(new Error('Tier payload missing ' + key + ' items'), 'tier_fetch', '/api/tiers');
      return items;
    }

    function bundleIdOf(item) {
      var props = item && item.properties;
      return props && typeof props._bundleId === 'string' ? props._bundleId.trim() : '';
    }

    // One box per cart: every bundle already there (mains and gifts) goes out by line key
    // in one call, unrelated items stay. If the cart cannot be read the tap fails and the
    // shopper tries again; nothing is ever cleared.
    async function removeExistingBundles(reportToken) {
      var cart = await fetchJson('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_verify', reportToken);
      var updates = {};
      var count = 0;
      (Array.isArray(cart && cart.items) ? cart.items : []).forEach(function (item) {
        if (bundleIdOf(item) && item.key) { updates[item.key] = 0; count++; }
      });
      if (!count) return false;
      await fetchJson('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }, 'cart_remove_existing', reportToken);
      return true;
    }

    function buildBundle(items, tier, bundleId) {
      return items.map(function (item) {
        var role = item._role;
        var flatDiscount = item.flatDiscount;
        var rest = Object.assign({}, item);
        delete rest._role;
        delete rest.flatDiscount;
        var p = Object.assign({}, rest.properties || {}, {
          _bundleId: bundleId,
          _role: role || 'main',
          _milestoneProgram: MILESTONE_PROGRAM,
          _milestoneTier: MILESTONE_TIER[tier],
        });
        if ((role || '').trim().toLowerCase() === 'gift' && flatDiscount != null && flatDiscount !== '') {
          p._flatDiscount = typeof flatDiscount === 'number' && Number.isFinite(flatDiscount) ? String(flatDiscount) : String(flatDiscount).trim();
        }
        rest.properties = p;
        return rest;
      });
    }

    async function addBundle(bundled, reportToken) {
      if (window.CartBundleAdd && typeof window.CartBundleAdd.smartAdd === 'function') {
        return withDeadline(window.CartBundleAdd.smartAdd(bundled, { reportToken: reportToken }), ADD_TIMEOUT_MS, 'cart_add', '/cart/add.js');
      }
      return fetchJson('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: bundled }),
      }, 'cart_add', reportToken);
    }

    // The Flow that tags milestone orders reads the order attribute, not only the line
    // properties (orders with the marker on lines alone were never tagged, 2026-09-04).
    // Attributes outlive the box they came with and Recharge copies them onto renewals, so
    // the stamp blanks the other program's key, as the taste profile and PDP stamps do: a
    // Labor Day or Brewzle box added and removed earlier must not ride onto this order.
    async function setAttributes(tier, reportToken) {
      await fetchJson('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        // _starterTierTest: '' so a taste profile visit's test arm does not ride onto this order.
        body: JSON.stringify({ attributes: { _milestoneProgram: MILESTONE_PROGRAM, _milestoneTier: MILESTONE_TIER[tier], _offerProgram: '', _starterTierTest: '' } }),
      }, 'cart_attributes', reportToken);
    }

    // Bundle ids end in the tap's timestamp; the id itself breaks a tie.
    function bundleTs(id) { var m = /_(\d+)$/.exec(id || ''); return m ? Number(m[1]) : 0; }
    function newerBundle(a, b) { if (b === null) return true; var ta = bundleTs(a), tb = bundleTs(b); return ta > tb || (ta === tb && a > b); }

    // The add is not atomic: an add the deadline gave up on can still land, two tabs can
    // each add a box, and smartAdd can fold an add into a same-tier main it saw. One read
    // after the add repairs all three: of the bundles in the cart the newest stays, every
    // other one goes out by key, and a kept main above quantity 1 goes back to 1.
    async function recheckBundles(reportToken) {
      var cart = await fetchJson('/cart.js', { headers: { Accept: 'application/json' } }, 'cart_recheck', reportToken);
      var items = Array.isArray(cart && cart.items) ? cart.items : [];
      var keep = null;
      items.forEach(function (item) { var id = bundleIdOf(item); if (id && newerBundle(id, keep)) keep = id; });
      var updates = {};
      var removed = 0;
      var fixed = 0;
      items.forEach(function (item) {
        var id = bundleIdOf(item);
        if (!id || !item.key) return;
        if (id !== keep) { updates[item.key] = 0; removed++; return; }
        var role = item.properties && item.properties._role;
        if (role === 'main' && Number(item.quantity) > 1) { updates[item.key] = 1; fixed++; }
      });
      if (removed || fixed) {
        await fetchJson('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }, 'cart_recheck', reportToken);
      }
      return { kept: keep, removed: removed, fixed: fixed };
    }

    function report(err, tier, key, reportToken) {
      var message = err && err.message ? err.message : String(err || 'Unknown cart failure');
      if (!window.WhiskyCartFailure || typeof window.WhiskyCartFailure.report !== 'function') return;
      window.WhiskyCartFailure.report({
        source: 'bof_page',
        stage: (err && err.stage) || (window.WhiskyCartFailure.inferStage ? window.WhiskyCartFailure.inferStage(message) : 'unknown'),
        error_message: message,
        http_status: err && err.http_status,
        cart_endpoint: err && err.cart_endpoint,
        _reportToken: (err && err._reportToken) || reportToken,
        tier_key: key,
        tier: tier,
        funnel_mode: 'redirect_checkout',
      });
    }

    // The label change on the focused button is not announced on its own, so the same
    // text goes into a visually hidden status region. A button can carry shorter labels
    // of its own (the sticky bar's is 105px wide).
    function say(text) { if (status) status.textContent = text || ''; }
    function labelTarget(btn) { return btn.querySelector('[data-bof-cta-label]') || btn; }
    function setLoading(btn, on, label) {
      var target = labelTarget(btn);
      if (!btn.hasAttribute('data-bof-label')) btn.setAttribute('data-bof-label', target.textContent);
      if (on) {
        var loading = btn.getAttribute('data-bof-loading-label') || LOADING_LABEL;
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        target.textContent = loading;
        say(LOADING_LABEL);
      } else {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        target.textContent = label || btn.getAttribute('data-bof-label');
        say(label || '');
      }
    }
    function retryLabel(btn) { return btn.getAttribute('data-bof-retry-label') || RETRY_LABEL; }

    // A failed tap says why when the reason is written for shoppers: Shopify's own 422
    // sentence or the shared add's connection-check line ("Please refresh the page and
    // try again"). The page's own technical messages ("/cart.js 500", timeouts) are not.
    var errorLine = root.querySelector('[data-bof-error]');
    function showError(err) {
      if (!errorLine) return;
      var message = err && err.message ? String(err.message) : '';
      var readable = message && message.charAt(0) !== '/' && /\s/.test(message) && /[.!]$/.test(message) && !/timed out|no JSON|Tier payload|API base|Cart kept bundle|Card shows variant|^\[/.test(message);
      errorLine.textContent = readable ? message : (errorLine.getAttribute('data-bof-error-default') || '');
      errorLine.hidden = !errorLine.textContent;
    }
    function clearError() {
      if (!errorLine) return;
      errorLine.hidden = true;
      errorLine.textContent = '';
    }

    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-bof-cta]') : null;
      if (!btn || !root.contains(btn)) return;
      var option = selectedOption();
      var tier = option ? (option.getAttribute('data-bof-tier') || '').trim() : '';
      var key = TIER_KEYS[tier];
      if (!key) {
        // No known tier: the link keeps its own href (the box's product page), and the miss is recorded.
        announce('failed', { tier: tier, tier_key: null, stage: 'unknown_tier', error_message: 'No tier key for "' + tier + '"' });
        return;
      }
      e.preventDefault();
      if (inFlight) return;
      inFlight = true;
      clearError();
      setLoading(btn, true);
      var bundleId = key + '_' + Date.now();
      var reportToken = {};
      var placement = btn.getAttribute('data-bof-cta') || '';
      announce('started', { tier: tier, tier_key: key, bundle_id: bundleId, placement: placement });
      (async function () {
        try {
          var items = await fetchTierItems(key);
          if (checkShownPlan(option, items, tier, key)) {
            throw tagError(new Error('Card shows variant ' + (option.getAttribute('data-variant-id') || '') + ' on plan ' + (option.getAttribute('data-selling-plan') || '') + '; /api/tiers adds another for ' + key), 'plan_mismatch', '/api/tiers');
          }
          await removeExistingBundles(reportToken);
          window.__TASTE_PROFILE_SUPPRESS_CART_DRAWER__ = true;
          await addBundle(buildBundle(items, tier, bundleId), reportToken);
          // A recheck that cannot read the cart does not undo or fail the add: the box is in
          // the cart, the read was lost (the Labor Day page stopped paging on this,
          // 2026-09-08). The event is the record; checkout shows the cart as it is.
          var repair;
          try {
            repair = await recheckBundles(reportToken);
          } catch (recheckErr) {
            announce('recheck_failed', { tier: tier, tier_key: key, bundle_id: bundleId, error_message: recheckErr && recheckErr.message ? recheckErr.message : String(recheckErr) });
            repair = { kept: bundleId, removed: 0, fixed: 0, checked: false };
          }
          // Never send the shopper to checkout with a box they did not tap. If this tap's
          // bundle is not the one the cart kept (another tab added later, or the shared add
          // folded this tap into a same-tier main), the tap fails and the next tap starts
          // clean by removing what is there.
          if (repair.kept !== bundleId) {
            throw tagError(new Error('Cart kept bundle ' + (repair.kept || 'none') + ' instead of ' + bundleId), 'cart_recheck', '/cart.js');
          }
          // The box is in the cart from here on; a failed attribute stamp must not read as a
          // failed add. It is retried inside fetchJson, then reported on its own and the
          // shopper goes on to checkout with the markers on the lines.
          try {
            await setAttributes(tier, reportToken);
          } catch (attrErr) {
            report(attrErr, tier, key, reportToken);
            announce('attributes_failed', { tier: tier, tier_key: key, bundle_id: bundleId, error_message: attrErr && attrErr.message ? attrErr.message : String(attrErr) });
          }
          announce('added', { tier: tier, tier_key: key, bundle_id: bundleId, placement: placement, item_count: items.length, kept_bundle_id: repair.kept, own_bundle_kept: repair.kept === bundleId, duplicates_removed: repair.removed, quantity_fixed: repair.fixed, recheck_ok: repair.checked !== false });
          // Give the analytics bundle a beat to flush the event before the page goes.
          setTimeout(function () { window.location.assign('/checkout'); }, 250);
        } catch (err) {
          window.__TASTE_PROFILE_SUPPRESS_CART_DRAWER__ = false;
          report(err, tier, key, reportToken);
          announce('failed', { tier: tier, tier_key: key, bundle_id: bundleId, placement: placement, stage: err && err.stage, error_message: err && err.message ? err.message : String(err) });
          inFlight = false;
          setLoading(btn, false, retryLabel(btn));
          showError(err);
          btn.focus();
        }
      })();
    });

    /* ---------- Gallery: the product page's image gallery, with a swipe; the rewards card follows the box ---------- */
    // PdpMediaGallery's behaviour: arrows and dots, and the arrows wrap from the last card to
    // the first. The track moves by transform (--bof-gallery-index); a finger drags it and
    // settles on the next card past a 40px or quick flick, the offer pages' hero carousel
    // thresholds. touch-action: pan-y on the stage leaves vertical scrolling to the browser.
    var galleryStage = root.querySelector('[data-bof-gallery-stage]');
    var galleryTrack = root.querySelector('[data-bof-gallery-track]');
    var galleryDots = root.querySelector('[data-bof-gallery-dots]');
    var rewardsSlide = galleryTrack ? galleryTrack.querySelector('[data-bof-slide="rewards"]') : null;
    var galleryIndex = 0;
    var galleryShown = 0;
    var SWIPE_THRESHOLD_PX = 40;
    var SWIPE_LOCK_PX = 10;

    function gallerySlides() {
      if (!galleryTrack) return [];
      return Array.prototype.filter.call(galleryTrack.children, function (li) { return !li.hidden; });
    }
    function slideName(slide) {
      var img = slide && slide.querySelector('img');
      return (slide && slide.getAttribute('data-bof-slide')) || (img && (img.getAttribute('src') || '').replace(/^.*\/(bof-[a-z0-9-]+)\.webp.*$/, '$1')) || null;
    }
    function renderDots() {
      if (!galleryDots) return;
      var slides = gallerySlides();
      var template = galleryDots.getAttribute('data-dot-label') || 'Image [n] of [total]';
      galleryDots.textContent = '';
      if (slides.length < 2) return;
      slides.forEach(function (slide, n) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-gallery__dot';
        dot.setAttribute('aria-label', template.replace('[n]', n + 1).replace('[total]', slides.length));
        dot.addEventListener('click', function () { goTo(n, 'dot'); });
        galleryDots.appendChild(dot);
      });
    }
    function paintGallery() {
      if (!galleryTrack) return;
      galleryTrack.style.setProperty('--bof-gallery-index', galleryIndex);
      galleryTrack.style.transform = '';
      var slides = gallerySlides();
      slides.forEach(function (slide, n) { slide.setAttribute('aria-hidden', n === galleryIndex ? 'false' : 'true'); });
      if (galleryDots) {
        Array.prototype.forEach.call(galleryDots.children, function (dot, n) {
          var on = n === galleryIndex;
          dot.classList.toggle('is-active', on);
          if (on) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
    function goTo(index, source) {
      var count = gallerySlides().length;
      if (!count) return;
      galleryIndex = ((index % count) + count) % count;
      paintGallery();
      if (galleryIndex === galleryShown) return;
      galleryShown = galleryIndex;
      announce('gallery_viewed', { index: galleryIndex + 1, slide: slideName(gallerySlides()[galleryIndex]), source: source || null, tier: root.getAttribute('data-bof-tier') || null });
    }
    // The Starter has no rewards after box 1, so its selection takes the rewards card out;
    // the picture on screen stays on screen when the card comes or goes.
    function syncRewards(tier) {
      if (!rewardsSlide) return;
      var match = null;
      var panels = rewardsSlide.querySelectorAll('[data-bof-rewards-tier]');
      for (var n = 0; n < panels.length; n++) {
        if (panels[n].getAttribute('data-bof-rewards-tier') === tier) match = panels[n];
      }
      if (match) {
        for (var p = 0; p < panels.length; p++) panels[p].hidden = panels[p] !== match;
      }
      if (rewardsSlide.hidden === !match) return;
      var slides = gallerySlides();
      var keep = slides[galleryIndex];
      if (keep === rewardsSlide) keep = slides[slides.indexOf(rewardsSlide) + 1] || slides[slides.indexOf(rewardsSlide) - 1];
      rewardsSlide.hidden = !match;
      renderDots();
      galleryIndex = Math.max(0, gallerySlides().indexOf(keep));
      galleryShown = galleryIndex;
      paintGallery();
    }
    if (galleryStage && galleryTrack) {
      root.querySelectorAll('[data-bof-gallery-step]').forEach(function (btn) {
        btn.addEventListener('click', function () { goTo(galleryIndex + Number(btn.getAttribute('data-bof-gallery-step')), 'arrow'); });
      });
      galleryStage.addEventListener('keydown', function (e) {
        if (e.target !== galleryStage) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(galleryIndex - 1, 'key'); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(galleryIndex + 1, 'key'); }
      });

      var drag = null;
      var endDrag = function (e, cancelled) {
        if (!drag) return;
        var d = drag;
        drag = null;
        galleryTrack.classList.remove('is-dragging');
        if (d.horizontal && !cancelled) {
          var dx = e.clientX - d.x;
          var quick = Math.abs(dx) > 20 && Date.now() - d.t < 250;
          var count = gallerySlides().length;
          var next = galleryIndex;
          if (Math.abs(dx) >= SWIPE_THRESHOLD_PX || quick) next = galleryIndex + (dx < 0 ? 1 : -1);
          // A swipe stops at the ends; the arrows wrap, as on the product page.
          next = Math.max(0, Math.min(count - 1, next));
          goTo(next, 'swipe');
        } else {
          paintGallery();
        }
      };
      galleryStage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest && e.target.closest('button')) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), horizontal: false, width: galleryStage.clientWidth || 1 };
      });
      galleryStage.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        var dy = e.clientY - drag.y;
        if (!drag.horizontal) {
          if (Math.abs(dx) > SWIPE_LOCK_PX && Math.abs(dx) > Math.abs(dy)) {
            drag.horizontal = true;
            galleryTrack.classList.add('is-dragging');
            if (galleryStage.setPointerCapture) {
              try { galleryStage.setPointerCapture(e.pointerId); } catch (captureErr) {}
            }
          } else if (Math.abs(dy) > SWIPE_LOCK_PX) {
            drag = null;
            return;
          } else {
            return;
          }
        }
        var count = gallerySlides().length;
        // Past either end the card follows the finger at a third of the distance.
        if ((galleryIndex === 0 && dx > 0) || (galleryIndex === count - 1 && dx < 0)) dx = dx / 3;
        galleryTrack.style.transform = 'translate3d(' + (-galleryIndex * drag.width + dx) + 'px, 0, 0)';
      });
      galleryStage.addEventListener('pointerup', function (e) { if (drag && e.pointerId === drag.id) endDrag(e, false); });
      galleryStage.addEventListener('pointercancel', function (e) { if (drag && e.pointerId === drag.id) endDrag(e, true); });
      // A two-finger sideways scroll on a trackpad, the old scroll row's desktop gesture.
      var wheelLock = 0;
      galleryStage.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (Date.now() < wheelLock || Math.abs(e.deltaX) < 8) return;
        wheelLock = Date.now() + 450;
        var count = gallerySlides().length;
        goTo(Math.max(0, Math.min(count - 1, galleryIndex + (e.deltaX > 0 ? 1 : -1))), 'wheel');
      }, { passive: false });
      renderDots();
      paintGallery();
    }

    /* ---------- Rating line: a link to the reviews section ---------- */
    var ratingLink = root.querySelector('[data-bof-rating]');
    if (ratingLink) {
      ratingLink.addEventListener('click', function (e) {
        var target = document.getElementById('bof-reviews');
        announce('rating_clicked', { found: !!target });
        if (!target) return;
        e.preventDefault();
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
        // Keyboard and screen-reader users land on the reviews, not back on the link.
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    }

    /* ---------- Hero burst: the selected box's three months of rewards, none for the Starter ---------- */
    var bonus = root.querySelector('[data-bof-bonus]');
    function syncBonus(tier) {
      if (!bonus || !tier) return;
      var amount = Number(bonus.getAttribute('data-bof-bonus-' + tier)) || 0;
      bonus.hidden = amount <= 0;
      var label = bonus.querySelector('[data-bof-bonus-amount]');
      if (label && amount > 0) label.textContent = '$' + amount;
    }

    /* ---------- Selection ---------- */
    var options = root.querySelectorAll('[data-bof-option]');
    var mainCta = root.querySelector('[data-bof-cta="main"]');
    var sticky = root.querySelector('[data-bof-sticky]');
    var ctaPrefix = root.getAttribute('data-cta-prefix') || '';
    var perShort = root.getAttribute('data-per-short') || '';

    function selectedOption() {
      for (var n = 0; n < options.length; n++) {
        if (options[n].classList.contains('is-selected')) return options[n];
      }
      return options[0] || null;
    }

    // The CTA, its no-JS link and the sticky bar's button always describe the selected box.
    function reflect(option) {
      if (!option) return;
      var dollars = option.getAttribute('data-plan-dollars') || '';
      var url = option.getAttribute('data-product-url') || '';
      root.setAttribute('data-bof-tier', option.getAttribute('data-bof-tier') || '');
      syncRewards(option.getAttribute('data-bof-tier') || '');
      syncBonus(option.getAttribute('data-bof-tier') || '');
      var label = ctaPrefix + ' \u2022 $' + dollars + '.' + (option.getAttribute('data-plan-cents') || '00') + perShort;
      [mainCta, sticky ? sticky.querySelector('[data-bof-cta]') : null].forEach(function (btn) {
        if (!btn) return;
        if (!btn.classList.contains('is-loading')) labelTarget(btn).textContent = label;
        btn.setAttribute('data-bof-label', label);
        if (url) btn.setAttribute('href', url);
      });
    }

    function select(option, source) {
      if (!option || inFlight) return;
      for (var n = 0; n < options.length; n++) {
        var on = options[n] === option;
        options[n].classList.toggle('is-selected', on);
        var input = options[n].querySelector('input[type="radio"]');
        if (input) input.checked = on;
      }
      reflect(option);
      // Back to the first picture, where the bonus burst shows the box just picked
      // (Harpawan, 2026-10-02).
      goTo(0, 'plan');
      announce('selected', {
        tier: option.getAttribute('data-bof-tier'),
        position: Number(option.getAttribute('data-position')) || null,
        source: source,
      });
    }

    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var option = input.closest('[data-bof-option]');
      if (!option || option.classList.contains('is-selected')) return;
      if (inFlight) {
        // A box is being added; keep the radio on the box that is going to the cart.
        var current = selectedOption();
        var keep = current && current.querySelector('input[type="radio"]');
        if (keep) keep.checked = true;
        return;
      }
      // Only the selected card is open, so picking a box below the open one collapses the
      // cards above it and the tapped card rose about 360px under the finger. It stays put.
      var topBefore = option.getBoundingClientRect().top;
      select(option, 'card');
      var shift = option.getBoundingClientRect().top - topBefore;
      if (Math.abs(shift) > 1) window.scrollBy(0, shift);
    });

    // The card's price and plan are read from the product; the cart adds what /api/tiers
    // says. If the two ever name different lines the tap fails before anything is removed
    // or added, and the failure is reported (it pages on the live theme), because the
    // shopper would otherwise be charged a price the card never showed.
    function checkShownPlan(option, items, tier, key) {
      if (!option) return false;
      var main = null;
      items.forEach(function (it) { if (!main && (it._role || '').toLowerCase() === 'main') main = it; });
      if (!main) return false;
      var shownVariant = option.getAttribute('data-variant-id') || '';
      var shownPlan = option.getAttribute('data-selling-plan') || '';
      var tierVariant = String(main.id || '');
      var tierPlan = main.selling_plan == null ? '' : String(main.selling_plan);
      if (shownVariant === tierVariant && shownPlan === tierPlan) return false;
      announce('plan_mismatch', { tier: tier, tier_key: key, shown_variant: shownVariant, shown_plan: shownPlan, tier_variant: tierVariant, tier_plan: tierPlan });
      return true;
    }

    // Chrome restores a checked radio after Back without a change event (the contact form's
    // 2026-09-25 lesson; the radios also carry autocomplete="off"): the card follows the radio.
    (function syncRestoredRadio() {
      var checked = root.querySelector('[data-bof-option] input[type="radio"]:checked');
      var option = checked ? checked.closest('[data-bof-option]') : null;
      if (option && !option.classList.contains('is-selected')) {
        for (var n = 0; n < options.length; n++) options[n].classList.toggle('is-selected', options[n] === option);
      }
    })();
    reflect(selectedOption());

    /* ---------- Sticky bar: shown while the main CTA is off screen, off over the footer ---------- */
    // Fixed to the bottom of the screen; it steps aside over the footer (it covered the
    // payment icons, the copyright line and the focus of the legal links).
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      // Harpawan (2026-10-02): visible whenever the main button is off screen, so the add is
      // always one tap away while the plan cards are read; still off over the footer.
      var inView = { cta: true, footer: false };
      var updateSticky = function () {
        var show = !inView.cta && !inView.footer;
        document.documentElement.classList.toggle('bof-sticky-on', show);
        if (sticky.hidden === !show) return;
        sticky.hidden = !show;
        if (show) announce('sticky_shown', { tier: root.getAttribute('data-bof-tier') });
      };
      var watch = function (el, key) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { inView[key] = entry.isIntersecting; });
          updateSticky();
        }).observe(el);
      };
      watch(mainCta, 'cta');
      // The footer comes after this script in the page, which can run before it is parsed.
      var watchFooter = function () {
        var footer = document.querySelector('footer.wl-footer') || document.querySelector('footer');
        if (footer) watch(footer, 'footer');
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchFooter);
      else watchFooter();
    }

    /* ---------- Delivery range: the page's one promise, pushed out by a later backend estimate ---------- */
    // Harpawan (2026-10-01): one promise everywhere, "Ships in 1 to 2 business days, arrives 5
    // to 8 business days after it ships", and a range built from the latest estimate, not the
    // earliest (the line read a single Monday). So the range is 6 to 10 business days from
    // today, and its end moves to the backend's maxDate when that is later.
    var deliveryDate = root.querySelector('[data-bof-delivery-date]');
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function formatDay(d) { return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate(); }
    function addBusinessDays(from, n) {
      var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n -= 1;
      }
      return d;
    }
    function showDelivery(latest, source) {
      if (!deliveryDate) return;
      var today = new Date();
      var start = addBusinessDays(today, 1 + 5);
      var end = addBusinessDays(today, 2 + 8);
      if (latest && latest > end) end = latest;
      deliveryDate.textContent = formatDay(start) + ' - ' + formatDay(end);
      root.setAttribute('data-bof-delivery-source', source);
    }
    if (deliveryDate) {
      showDelivery(null, 'promise');
      var dctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var dtimer = dctrl ? setTimeout(function () { dctrl.abort(); }, 3000) : null;
      fetch(apiBase + '/api/delivery/estimate', { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'omit', mode: 'cors', cache: 'no-store', signal: dctrl ? dctrl.signal : undefined })
        .then(function (res) { if (!res.ok) throw new Error('delivery ' + res.status); return res.json(); })
        .then(function (json) {
          var data = json && json.data;
          var iso = data && (typeof data.maxDate === 'string' ? data.maxDate : data.minDate);
          var d = typeof iso === 'string' ? new Date(iso + 'T00:00:00') : null;
          if (!d || isNaN(d.getTime())) throw new Error('delivery payload');
          showDelivery(d, data.source || 'estimate');
        })
        .catch(function () { /* the promise's range is already on screen */ })
        .then(function () { if (dtimer) clearTimeout(dtimer); });
    }

    /* ---------- Accordions: one event per opening ---------- */
    root.querySelectorAll('details[data-bof-acc]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) announce('accordion_opened', { accordion: d.getAttribute('data-bof-acc') });
      });
    });

    /* ---------- Member videos: swipe row, arrows, progress line, in-page player ---------- */
    var videoRow = root.querySelector('[data-bof-videos-row]');
    var videoFill = root.querySelector('[data-bof-videos-fill]');
    var videoControls = root.querySelector('[data-bof-videos-controls]');
    var videoPrev = root.querySelector('[data-bof-videos-step="-1"]');
    var videoNext = root.querySelector('[data-bof-videos-step="1"]');
    if (videoRow) {
      // Arrows grey out at either end, and the controls go when every video fits.
      var updateFill = function () {
        var max = videoRow.scrollWidth - videoRow.clientWidth;
        if (videoControls) {
          videoControls.hidden = max <= 1;
          videoControls.classList.toggle('is-needed', max > 1);
        }
        if (videoPrev) videoPrev.disabled = videoRow.scrollLeft <= 1;
        if (videoNext) videoNext.disabled = videoRow.scrollLeft >= max - 1;
        if (!videoFill) return;
        var share = videoRow.scrollWidth ? videoRow.clientWidth / videoRow.scrollWidth : 1;
        var pos = max > 0 ? videoRow.scrollLeft / max : 0;
        videoFill.style.width = Math.round(Math.min(1, share) * 100) + '%';
        videoFill.style.left = Math.round((1 - Math.min(1, share)) * pos * 100) + '%';
      };
      videoRow.addEventListener('scroll', updateFill, { passive: true });
      window.addEventListener('resize', updateFill);
      updateFill();
      root.querySelectorAll('[data-bof-videos-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tile = videoRow.querySelector('li');
          var step = tile ? tile.getBoundingClientRect().width + 9 : 150;
          videoRow.scrollBy({ left: step * Number(btn.getAttribute('data-bof-videos-step')), behavior: 'smooth' });
        });
      });
    }
    var player = root.querySelector('[data-bof-player]');
    var playerVideo = player ? player.querySelector('video') : null;
    var playerOpener = null;
    function closePlayer() {
      if (!player || player.hidden) return;
      playerVideo.pause();
      playerVideo.removeAttribute('src');
      playerVideo.load();
      player.hidden = true;
      if (playerOpener && playerOpener.focus) playerOpener.focus();
      playerOpener = null;
    }
    if (player && playerVideo) {
      root.addEventListener('click', function (e) {
        var link = e.target && e.target.closest ? e.target.closest('[data-bof-video]') : null;
        if (!link || !root.contains(link)) return;
        e.preventDefault();
        playerOpener = link;
        playerVideo.src = link.getAttribute('data-bof-video');
        player.hidden = false;
        player.querySelector('[data-bof-player-close]').focus();
        playerVideo.play().catch(function () {});
        announce('video_played', { index: Number(link.getAttribute('data-bof-video-index')) || null });
      });
      player.querySelector('[data-bof-player-close]').addEventListener('click', closePlayer);
      player.addEventListener('click', function (e) { if (e.target === player) closePlayer(); });
      document.addEventListener('keydown', function (e) {
        if (player.hidden) return;
        if (e.key === 'Escape') { closePlayer(); return; }
        // Keep Tab inside the dialog: the close button and the video's controls.
        if (e.key === 'Tab') {
          var first = player.querySelector('[data-bof-player-close]');
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); playerVideo.focus(); }
          else if (!e.shiftKey && document.activeElement === playerVideo) { e.preventDefault(); first.focus(); }
        }
      });
    }

    // Back from checkout (bfcache): the button must not stay on the loading label.
    window.addEventListener('pageshow', function () {
      inFlight = false;
      root.querySelectorAll('[data-bof-cta][data-bof-label]').forEach(function (b) { setLoading(b, false); });
    });
  }
})();
